import { render, staticRenderFns } from "./settlementDetail.vue?vue&type=template&id=56202a8f&scoped=true"
import script from "./settlementDetail.vue?vue&type=script&lang=js"
export * from "./settlementDetail.vue?vue&type=script&lang=js"
import style0 from "./settlementDetail.vue?vue&type=style&index=0&id=56202a8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56202a8f",
  null
  
)

export default component.exports